import { inject, Pipe, PipeTransform } from '@angular/core';

import { MaskitoPipe } from '@maskito/angular';

import { isNumber } from 'lodash-es';

import { amountMask } from '../../constants/maskito.constants';
import { selectNonFloatNumberCharacters } from '../../constants/regular-expressions.constant';

type CurrencyInputType = string | number | undefined | null;

const defaultValue = '--';

@Pipe({
  name: 'redCurrency',
  standalone: false
})
export class UsdCurrencyPipe implements PipeTransform {
  private maskito = inject(MaskitoPipe);

  transform(value: CurrencyInputType, backupValue: string | number = defaultValue, decimalCount?: number) {
    let result = backupValue;
    const number = parseFloat((value?.toString() || '').replace(selectNonFloatNumberCharacters, ''));
    if (isNaN(number) && isNumber(backupValue)) {
      result = this.maskito.transform(decimalCount ? backupValue.toFixed(decimalCount) : backupValue, amountMask);
    } else if (!isNaN(number)) {
      result = this.maskito.transform(decimalCount ? number.toFixed(decimalCount) : number, amountMask);
    }

    return result;
  }
}
